import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixSelect from '@radix-ui/react-select';
import { styled } from 'styletron-react';
import { sizes } from '../../../../const/sizes';
import { zIndexes } from '../../../../const/zIndexes';
import { useFloatingSurfaceStyle } from '../../../../hooks/useFloatingSurfaceStyle';
import { SelectBase } from '../SelectBase';
import { SelectItem, SelectItemContent } from '../SelectItem';
const StyledContent = styled(RadixSelect.Content, (p) => ({
    ...p.$floatingSurfaceStyle,
    maxHeight: sizes.select.maxHeight,
    width: 'var(--radix-select-trigger-width)',
    zIndex: zIndexes.select,
}));
export const Select = ({ options, position, withIndicator, ...props }) => {
    const floatingSurfaceStyle = useFloatingSurfaceStyle();
    return (_jsx(SelectBase, { ...props, children: _jsx(StyledContent, { $floatingSurfaceStyle: floatingSurfaceStyle, position: position, children: _jsx(RadixSelect.Viewport, { children: options.map((option, index) => {
                    const isLast = index === options.length - 1;
                    return (_jsx(SelectItem, { value: option.value, testId: option.testId, children: _jsx(SelectItemContent, { text: option.text, withDivider: !isLast, withIndicator: withIndicator }) }, option.value));
                }) }) }) }));
};
